var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutDrop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-right-to-bracket"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.4259 9.32255L14.7795 8.969L14.4259 9.32256C14.4482 9.34483 14.4667 9.37191 14.4804 9.40501C14.5053 9.4654 14.5053 9.5346 14.4804 9.59499C14.466 9.62966 14.4475 9.65616 14.4279 9.67553L14.4259 9.67745L11.4267 12.6767C11.3778 12.7256 11.3145 12.75 11.25 12.75C11.1855 12.75 11.1222 12.7256 11.0733 12.6767C10.9753 12.5787 10.9753 12.4213 11.0733 12.3233L12.7931 10.6036L13.6466 9.75H12.4395H6C5.86172 9.75 5.75 9.63818 5.75 9.5C5.75 9.36182 5.86172 9.25 6 9.25H12.4395H13.6466L12.7931 8.39645L11.0733 6.6767C10.9753 6.57871 10.9753 6.42129 11.0733 6.3233C11.1713 6.22532 11.3287 6.22532 11.4267 6.3233L14.4259 9.32255ZM5.25 14.5H7.5C7.63828 14.5 7.75 14.6118 7.75 14.75C7.75 14.8882 7.63828 15 7.5 15H5.25C4.28564 15 3.5 14.2144 3.5 13.25V5.75C3.5 4.78564 4.28564 4 5.25 4H7.5C7.63828 4 7.75 4.11182 7.75 4.25C7.75 4.38818 7.63828 4.5 7.5 4.5H5.25C4.55953 4.5 4 5.06093 4 5.75V13.25C4 13.9391 4.55953 14.5 5.25 14.5Z",
    fill: "#374151",
    stroke: "#F05252"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutDrop);
export default __webpack_public_path__ + "static/media/logoutDrop.4931ec521df4348246700c04ff9bc6a7.svg";
export { ForwardRef as ReactComponent };